import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import { DashboardContainer } from './Dashboard.styles';

const Dashboard: React.FC = () => {
    return (
        <DashboardContainer>
            <Navbar />
            <Outlet />
        </DashboardContainer>
    );
};

export default Dashboard;
